<template>
  <!-- Date de naissance connue, ou âge déclaré (« environ 4 ans ») : jamais bloquant -->
  <div>
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-1">
      <label class="form-label fw-semibold mb-0">Date de naissance</label>
      <div class="btn-group btn-group-sm" role="group">
        <button type="button" class="btn" :class="!estimee ? 'btn-primary' : 'btn-outline-primary'" @click="choisir(false)">Date connue</button>
        <button type="button" class="btn" :class="estimee ? 'btn-primary' : 'btn-outline-primary'" @click="choisir(true)">Âge estimé</button>
      </div>
    </div>

    <input v-if="!estimee" type="date" class="form-control form-control-clinique" :max="maxDate"
           :value="dateNaissance || ''" @input="$emit('update:dateNaissance', $event.target.value)">

    <div v-else class="input-group">
      <input type="number" min="0" max="120" class="form-control form-control-clinique" placeholder="ans" v-model.number="annees" @input="calculer">
      <span class="input-group-text">ans</span>
      <input type="number" min="0" max="11" class="form-control form-control-clinique" placeholder="mois" v-model.number="mois" @input="calculer">
      <span class="input-group-text">mois</span>
    </div>

    <div class="form-text">
      <template v-if="age">
        Âge : <strong>{{ age }}</strong>
        <span v-if="mineur" class="badge bg-info-subtle text-info-emphasis ms-1">Mineur</span>
      </template>
      <template v-else-if="estimee">Indiquez l'âge déclaré : la date sera à confirmer plus tard.</template>
      <template v-else>Inconnue ? Choisissez « Âge estimé », ou laissez vide : le dossier sera marqué à compléter.</template>
    </div>
  </div>
</template>

<script>
import { ageAffiche, estMineur, dateDepuisAge } from '@/utils/age'

export default {
  name: 'AgeNaissance',
  props: {
    dateNaissance: { type: String, default: '' },
    estimee: { type: Boolean, default: false },
  },
  emits: ['update:dateNaissance', 'update:estimee'],
  data() {
    return { annees: null, mois: null }
  },
  computed: {
    age() { return ageAffiche(this.dateNaissance, this.estimee) },
    mineur() { return estMineur(this.dateNaissance) === true },
    maxDate() { const d = new Date(); const z = x => String(x).padStart(2, '0'); return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}` },
  },
  methods: {
    choisir(estimee) {
      if (estimee === this.estimee) return
      this.$emit('update:estimee', estimee)
      if (estimee) {
        this.annees = null
        this.mois = null
      }
    },
    calculer() {
      this.$emit('update:dateNaissance', dateDepuisAge(this.annees, this.mois))
    },
  },
}
</script>
